// extracted by mini-css-extract-plugin
export default {"outerGrid":"GridView_outerGrid__IMWtu","companyGroup":"GridView_companyGroup__z+-FP","grid":"GridView_grid__PvcD9"};